// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AthletesAttendanceController from "./athletes_attendance_controller.js";
application.register("athletes-attendance", AthletesAttendanceController);
